<template>
  <v-container>
    <div>
      <s-crud :filter="filter" :config="config" edit :enable="selected.RcfState >= 4 ? true : false"
        @enable="enableLP()" :transfer="selected.RcfState < 4 ? true : false" @transfer="TransferLP()"
        @save="save($event)" @EditEvent="editEvent()" height="auto" @rowSelected="rowSelected($event)" search-input
        ref="gridReceptionFresh" :title="title" no-full :sync="$fun.hasSpecialPermission('syncLot')" @sync="syncLot()">

        <template v-slot:filter>
          <v-container>
            <v-row style="margin-left: 5px" justify="center">
              <v-col cols="6" md="6" lg="3" class="pb-0 pt-1">
                <s-date label="Fecha Inicio" v-model="filter.cDateInitial"></s-date>
              </v-col>
              <v-col cols="6" md="6" lg="3" class="pb-0 pt-1">
                <s-date label="Fecha Fin" v-model="filter.cDateFin"></s-date>
              </v-col>

              <v-col cols="6" md="6" lg="3" v-if="filter.filterAll == 0" class="pb-0 pt-1">
                <s-select-definition clearable :def="1172" label="Tipo Cultivo" v-model="filter.TypeCrop" />
              </v-col>
              <v-col cols="6" md="6" lg="3" v-if="filter.filterAll == 0" class="pb-0 pt-1">
                <s-select-definition clearable :def="1173" label="Cultivo" v-model="filter.TypeCultive" />
              </v-col>

              <v-col cols="6" md="6" lg="3" v-if="filter.filterAll == 0" class="pb-0 pt-1">
                <s-select-variety clearable :cultiveID="filter.TypeCultive" label="Variedad" full
                  v-model="filter.VrtID" />
              </v-col>

              <v-col cols="6" md="6" lg="3" v-if="filter.filterAll == 0" class="pb-0 pt-1">
                <s-select-definition clearable label="Tipo de Servicio" :def="1171"
                  v-model="filter.cTypeServiceID"></s-select-definition>
              </v-col>

              <v-col cols="6" md="6" lg="3" v-if="filter.filterAll == 0" class="pb-0 pt-1">
                <s-select-type-certification clearable label="Certificacion" full
                  v-model="filter.TcrID"></s-select-type-certification>
              </v-col>

              <v-col cols="6" md="6" lg="3" v-if="filter.filterAll == 0" class="pb-0 pt-1">
                <s-select-definition :def="1230" label="Planta Procesadora" v-model="filter.TypeProcessingPlant"
                  clearable />
              </v-col>
            </v-row>
            <v-row style="margin-left: 5px">
              <v-col cols="6" lg="3" md="3" class="pt-1">
                <s-select-definition clearable label="Estado" :def="1256"
                  v-model="filter.TypeState"></s-select-definition>
              </v-col>
              <v-col cols="6" lg="3" md="3" class="pt-1" v-if="filter.TypeProcessingPlant == 2">
                <s-select-definition :def="1226" v-model="filter.TypeBaler" clearable />
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" lg="2" class="mt-3 pb-0">
                <v-btn style="color: white" small color="warning" rounded :disabled="disabledCorrelative(selected)"
                  block @click="generateCorrelative(selected)">
                  Generar Correlativo
                </v-btn>
              </v-col>
              <v-col cols="6" lg="2" class="mt-3 pb-0">
                <v-btn style="color: white" small color="info" rounded block @click="WeighMaterial()">
                  Pesado
                </v-btn>
              </v-col>
              <v-col cols="6" lg="2" class="mt-3 pb-0">
                <v-btn @click="ModalBrix()" style="color: white" small rounded block color="success">
                  Muestreo
                </v-btn>
              </v-col>

              <!-- <v-col cols="6" sm="2" v-if="ship == 2">
								<v-btn 
									@click="dialogDecrease = true"
									style="color: white"
									small
									rounded
									block
									color="warning"
								>
									Merma
								</v-btn>
							</v-col> -->
            </v-row>
          </v-container>
        </template>

        <template v-slot:ViewCert="{ row }">
          <v-btn x-small color="info" block outlined @click="clickView(row)">
            <v-icon style="font-size: 16px !important">fas fa-eye</v-icon>
          </v-btn>
        </template>


        <template v-slot:UploadFile="{ row }">
          <v-btn x-small :color="row.HvsAttach ? '#6ad898' : '#b2b2b2'" block outlined @click="clickUploadFile(row)">
            <v-icon style="font-size: 16px !important">{{ row.HvsAttach ? 'fas fa-file-alt' : 'fas fa-file' }}</v-icon>
          </v-btn>
        </template>

        <template slot-scope="props">
          <alert-supplies :FltID="objLot.FltID"></alert-supplies>

          <!-- <v-btn
						@click="openAudio()"
						:color="props.item.TypeStateColor"
						v-if="disabledAll == true"
						style="
							transform: rotate(339deg);
							z-index: 9999;
							left: 0%;
							top: 30%;
							width: inherit;
							opacity: 80%;
							"
						>{{ props.item.TypeStateName }}
					</v-btn> -->
          <!-- <i
            v-if="disabledAll == true"
            class="fa fa-fingerprint"
            style="
              font-size: 265px;
              cursor: pointer;
              position: fixed;
              left: 40%;
              z-index: 99999;
              color: #8e8f91;
            "
            @click="openAudio()"
          ></i> -->

          <v-card :disabled="disabledAll">
            <!-- Inicio Datos Recepcion Vigilancia -->
            <v-row>
              <div class="col-md-12 col-sm-12">
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-toolbar dense dark :color="'#BAB6B5'"
                        style=" height: 28px; -webkit-box-shadow: 2px 1px 0px 0px rgb(0 0 0 / 10%), 0px 0px 0px 0px rgb(0 0 0 / 4%), 0px 1px 0px 0px rgb(0 0 0 / 2%); border-radius: 5px; ">
                        <v-toolbar-title style="height: 38px">Datos Recepcion Vigilancia</v-toolbar-title>
                      </v-toolbar>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p>
                        Fecha Recepcion:
                        {{ props.item.RcfDateReceptionSurveillance }}
                      </p>
                    </v-col>
                    <v-col cols="6" md="3">
                      <p>Planta Procesadora:</p>
                    </v-col>
                    <v-col cols="6" md="3">
                      <s-select-definition :def="1230" v-model="props.item.TypeProcessingPlant" />
                    </v-col>
                    <v-col cols="12" md="6" style="margin-top: -35px">
                      <p>
                        Nro. Recepcion:
                        {{ props.item.RcsID }}
                      </p>
                    </v-col>
                    <v-col cols="6" md="3" style="margin-top: -30px" v-if="props.item.TypeProcessingPlant == 2">
                      <p>Empacadora:</p>
                    </v-col>
                    <v-col cols="6" md="3" style="margin-top: -30px" v-if="props.item.TypeProcessingPlant == 2">
                      <s-select-definition :def="1226" v-model="props.item.TypeBaler" />
                    </v-col>
                  </v-row>
                </v-col>
              </div>
            </v-row>
            <!-- Fin Datos Recepcion Vigilancia -->

            <!-- Inicio Fundo || Vehiculos  -->
            <v-row style="margin-top: -30px; margin-bottom: -40px">
              <!-- Inicio Fundo/User -->
              <div class="col-lg-12 col-md-12">
                <v-card outlined rounded elevation="2" dense>
                  <v-card-text>
                    <b>Datos de Fundo - </b>
                    <b>{{ objLot.FltCodSenasa }}</b>
                  </v-card-text>
                  <v-card-actions>
                    <v-row>
                      <v-col lg="2" md="2" cols="12">
                        <s-search-lot-by-cod-senasa @searchSenasa="searchSenasa($event)" />
                      </v-col>

                      <v-col cols="12" lg="4" md="4">
                        <s-text label="Productor" v-model="objLot.PrdText" readonly></s-text>
                      </v-col>

                      <v-col cols="12" lg="4" md="4">
                        <s-text readonly label="Fundo" v-model="objLot.FagName"></s-text>
                      </v-col>

                      <v-col cols="12" lg="2" md="2">
                        <s-text readonly label="Lote" v-model="objLot.FltName"></s-text>
                      </v-col>

                      <v-col cols="6" md="2" style="margin-top: -15px">
                        <s-select-definition label="Tipo de Servicio" :def="1171" v-model="props.item.TypeService" />
                      </v-col>

                      <v-col cols="6" md="2" style="margin-top: -15px">
                        <s-select-definition :def="1174" label="Procedencia" v-model="props.item.TypeOrigin" />
                      </v-col>

                      <v-col cols="6" md="2" style="margin-top: -15px">
                        <s-select-definition :def="1172" label="Tipo Cultivo" v-model="objLot.TypeCrop" />
                      </v-col>
                      <v-col cols="6" md="2" style="margin-top: -15px">
                        <s-select-definition :def="1173" label="Cultivo" v-model="objLot.TypeCultive" readonly />
                      </v-col>

                      <v-col cols="6" md="2" style="margin-top: -15px">
                        <s-select-variety :cultiveID="objLot.TypeCultive" label="Variedad" full
                          :text="props.item.VrtName" :value="objLot.VrtID" v-model="objLot.VrtID" readonly />
                      </v-col>
                      <v-col cols="6" md="2" style="margin-top: -15px">
                        <s-text label="ID Fruta: " v-model="objLot.FltID"></s-text>
                      </v-col>

                      <v-col cols="12" md="4" style="margin-top: -15px">
                        <v-text-field label="Direccion: " v-model="objLot.FagAddress" readonly></v-text-field>
                      </v-col>

                      <v-col cols="6" md="4" style="margin-top: -15px">
                        <v-text-field label="Zona: " v-model="objLot.ZonIDText" readonly></v-text-field>
                      </v-col>

                      <v-col cols="6" md="4" style="margin-top: -15px">
                        <v-text-field label="Sub Zona: " v-model="objLot.SzoIDText" readonly></v-text-field>
                      </v-col>

                      <v-col cols="6" md="2" style="margin-top: -15px">
                        <s-select-definition label="Tipo de Negociacion:" :def="1610" v-model="objLot.TypeNegociation"
                          readonly></s-select-definition>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </div>
              <!-- Fin Fundo/User -->

              <!-- Inicio Vehicle -->
              <div class="col-lg-12 col-md-12" style="margin-top: -20px">
                <v-col cols="12" md="12">
                  <v-card outlined rounded elevation="2">
                    <v-card-text>
                      <b>Datos de Vehiculo</b>
                    </v-card-text>
                    <!-- <v-card-actions> -->
                    <v-row>
                      <v-col cols="12" md="12" style="margin-top: 0px">
                        <v-data-table item-key="RcsTptID" dense :items="itemsVehicle" :headers="headersVehicle"
                          v-model="selectedVehicle" :items-per-page="-1" @click:row="rowClickVehicle"
                          hide-default-footer disable-sort>
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.TptEnrollment="props">
                            <s-select-transport :value="props.item.TptEnrollment" full
                              v-model="props.item.TptEnrollment">
                            </s-select-transport>
                          </template>
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.TptDriver="props">
                            <s-select-driver clearable full :value="props.item.TptDriver"
                              v-model="props.item.TptDriver">
                            </s-select-driver>
                          </template>
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.TypeLoadName="props">
                            <s-select-definition :def="1229" v-model="props.item.TypeLoad" />
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <!-- </v-card-actions> -->
                  </v-card>
                </v-col>
              </div>
              <!-- Fin Vehicle -->
            </v-row>

            <!-- Fin Fundo || Vehiculos  -->

            <!-- Inicio Capataz -->
            <v-row>
              <div class="col-lg-12 col-md-12">
                <v-col cols="12" md="12">
                  <v-card outlined rounded elevation="2">
                    <v-card-text>
                      <b>Datos de Capataz</b>
                    </v-card-text>

                    <!-- <v-card-actions> -->
                    <!-- <v-row style="margin:auto">
											
										</v-row> -->
                    <v-row>
                      <!-- <v-col
												cols="6"
												v-if="selectedGang.length > 0"
											>
												<s-select-transport
													clearable
													full
													v-model="
														selectedGang[0].VehPlate
													"
													label="Placa"
												>
												</s-select-transport>
											</v-col>
											<v-col
												cols="6"
												v-if="selectedGang.length > 0"
											>
												<s-select-driver
													label="Chofer"
													clearable
													full
													v-model="
														selectedGang[0]
															.DriverName
													"
												/>
											</v-col> -->
                      <v-col cols="12">
                        <v-data-table item-key="RcsGngID" dense :items="itemsGang" :headers="headersGang"
                          v-model="selectedGang" :items-per-page="-1" @click:row="rowClickGang" hide-default-footer
                          disable-sort>
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.FrmQuantityReal="props">
                            <s-text v-model="props.item.FrmQuantityReal" number></s-text>
                          </template>
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.FrmQuantityHarvester="props">
                            <s-text v-model="props.item.FrmQuantityHarvester" number></s-text>
                          </template>
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.TypeChargeName="props">
                            <s-text v-model="props.item.TypeChargeName" readonly></s-text>
                          </template>
                          <!-- :value="props.item.FrmID" -->
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.FrmName="props">
                            <s-select-foreman clearable full v-model="props.item.FrmID"></s-select-foreman>
                          </template>
                          <!-- eslint-disable-next-line vue/valid-v-slot -->
                          <template v-slot:item.FltName="props">
                            <s-select-lot v-if="objLot.FltID" :fkFltID="objLot.FltID" :PrdID="objLot.PrdID"
                              v-model="props.item.FltID" clearable full />
                          </template>
                        </v-data-table></v-col>
                    </v-row>
                    <!-- </v-card-actions> -->
                  </v-card>
                </v-col>
              </div>
            </v-row>
            <!-- Fin Capataz -->

            <!-- Inicio Documentos || Datos Lote Recepcion  -->
            <v-row style="margin: auto">
              <!--Inicio datos Lote -->
              <v-col cols="12" lg="4" md="4">
                <v-card flat outlined>
                  <v-card-text>
                    <b>Lote de Recepcion</b>
                  </v-card-text>

                  <v-card-actions>
                    <v-row>
                      <v-col cols="12" md="12" style="margin-top: 0px">
                        <s-select-definition clearable label="Zona Ubicacion" v-model="props.item.TypeZonLocation"
                          :def="1253" />
                      </v-col>
                      <!-- <v-col cols="6" md="6" style="margin-top: 0px">
												<s-select-definition
													clearable
													label="Calidad"
													v-model="
														props.item.TypeQualityExportation
													"
													:def="1254"
												/>
											</v-col> -->
                      <v-col cols="6" md="6" style="margin-top: -10px">
                        <s-text label="Peso Recepción" v-model="props.item.WbbNetWeight" decimal readonly />
                      </v-col>

                      <v-col cols="6" md="6" style="margin-top: -10px">
                        <s-select-definition clearable label="Alerta" v-model="props.item.TypeAlert" :def="1312" />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
              <!--Fin datos Lote -->

              <!--Inicio Documentos -->
              <v-col cols="12" lg="8" md="8">
                <v-card flat outlined>
                  <v-card-text>
                    <b>Documentos || </b>
                    <span style="
                        margin-left: 2%;
                        color: red;
                        font-size: 11px;
                        position: absolute;
                      ">
                      <b>Campos Obligatorios (*)</b>
                    </span>
                  </v-card-text>

                  <v-card-actions>
                    <v-row>
                      <v-col cols="6" :md="selected.FrzID == 0 ? 3 : 6" style="margin-top: 0px">
                        <s-text :label="selected.FrzID == 0
                          ? 'Nro. Guia de Cosecha'
                          : 'N° Guia interna'
                          " type="text" v-model="props.item.RcfNumberHarvestGuide" :mask="maskFormatGuideHarvested">
                          <template v-slot:append>
                            <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                          </template>
                        </s-text>
                      </v-col>

                      <v-col cols="6" md="3" style="margin-top: 0px" v-if="selected.FrzID == 0">
                        <s-text label="Nro. Guia de Remision" type="text" v-model="props.item.RcfNumberReferralGuide"
                          :mask="maskFormatGuideRemission">
                          <template v-slot:append>
                            <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                          </template>
                        </s-text>
                      </v-col>

                      <v-col cols="6" md="3" style="margin-top: 0px" v-if="selected.FrzID == 0">
                        <s-text label="Precinto Sunshine" type="text" v-model="props.item.RcfSunshineSeal">
                          <template v-slot:append>
                            <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                          </template>
                        </s-text>
                      </v-col>

                      <v-col cols="6" md="3" style="margin-top: 0px" v-if="selected.FrzID == 0">
                        <s-text label="Precinto Senasa" type="text" v-model="props.item.RcfSenasaSeal" />
                      </v-col>

                      <v-col cols="6" md="3" style="margin-top: -10px" v-if="selected.FrzID == 0">
                        <!-- :mask="'###-###############'" -->
                        <s-text label="N.G.R Transportista" type="text" v-model="props.item.RcfNumberFerralGuideDriver">
                          <template v-slot:append>
                            <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                          </template>
                        </s-text>
                      </v-col>

                      <v-col cols="6" md="3" style="margin-top: -10px" v-if="selected.FrzID == 0">
                        <s-text label="N.G.R-Materiales" type="text" v-model="props.item.RcfNumberFerralGuideMaterials"
                          :mask="'###-###############'" />
                      </v-col>

                      <v-col cols="6" md="3" style="margin-top: -10px" v-if="selected.FrzID == 0">
                        <s-text label="N.G.R Trans-Materiales" type="text" v-model="props.item.RcfNumberFerralGuideDriverMaterials
                          " />
                      </v-col>
                      <!-- :mask="'###-###############'" -->
                      <v-col cols="6" :md="selected.FrzID == 0 ? 3 : 6"
                        :style="selected.FrzID == 0 ? 'margin-top: -10px' : ''">
                        <s-text label="Peso Guia" decimal v-model="props.item.RcfWeightGuide"
                          :readonly="selected.FrzID > 0 ? true : false">
                        </s-text>
                        <s-text label="Peso Ticket" decimal v-model="props.item.RcfWeightTicket"
                          :readonly="selected.FrzID == 0 && selected.TypeShip == 4 ? true : false">
                        </s-text>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
              <!--Fin Documentos -->
            </v-row>

            <v-row>
              <div class="col-md-12 col-lg-12" cols="12">
                <v-col cols="12" md="12" style="margin-top: -20px">
                  <s-textarea style="margin-top: -15px" v-model="props.item.RcfObservations"
                    label="Observaciones"></s-textarea>
                </v-col>
              </div>
            </v-row>
            <!-- Fin Documentos || Datos Lote Recepcion -->
          </v-card>
        </template>

        <template v-slot:RcfState="{ row }">
          <v-chip x-small :color="row.TypeStateColor">
            {{ row.TypeStateName }}
          </v-chip>
        </template>

        <template v-slot:TypeAlert="{ row }">
          <v-chip x-small :color="row.TypeAlertColor">
            {{ row.TypeAlertName }}
          </v-chip>
        </template>

        <template v-slot:CloseLot="{ row }">
          <v-btn v-if="row.RcfState < 4 && row.Sampling == 1" x-small :color="row.TypeStateColor" rounded
            style="border-radius: 10px; text-transform: none" @click="closeLot(row)">{{ "Cerrar" }}
            <!-- <v-icon style="font-size: 16px !important">fas fa-eye</v-icon> -->
          </v-btn>
        </template>

        <!-- :v-model="row.RcfWeightGuide > 0 ? true : false" -->
        <template v-slot:WeightGuideVB="{ row }">
          <v-switch disabled style="margin-top: -1px" hide-details :input-value="row.RcfWeightGuide > 0"
            hide-spin-buttons> </v-switch>
          <!-- <v-chip x-small :color="row.RcfWeightGuide > 0 ? 'success': 'error'">
            {{row.RcfWeightGuide > 0 ? 'Si': 'No'}}
            
          </v-chip> -->
        </template>

        <template v-slot:RcfID="{ row }">

          {{ row.RcfID }} - {{ row.RcfCode }}

        </template>

        <template v-slot:DeclineLot="{ row }">

          <v-btn v-if="row.RcfState <= 3 && $fun.hasSpecialPermission('rejectLot')" x-small :color="row.TypeStateColor"
            rounded style="border-radius: 10px; text-transform: none" @click="DeclineLot(row)">{{ "Rechazar" }}
            <!-- <v-icon style="font-size: 16px !important">fas fa-eye</v-icon> -->
          </v-btn>
          <v-btn v-if="row.RcfState == 12 && $fun.hasSpecialPermission('rejectLot')" x-small :color="row.TypeStateColor"
            rounded style="border-radius: 10px; text-transform: none" @click="ReceptionLot(row)">{{ "Recepcionar" }}
            <!-- <v-icon style="font-size: 16px !important">fas fa-eye</v-icon> -->
          </v-btn>
        </template>
      </s-crud>
    </div>

    <v-dialog v-if="openDialogView" v-model="openDialogView" persistent style="display: contents" width="70%">
      <s-certification-lot :RcfID="RcfIDCert" @close="closeCert()" />
    </v-dialog>

    <!-- ventana modal de pesos  -->
    <v-dialog v-model="dialogWeigh" v-if="dialogWeigh" fullscreen hide-overlay persistent
      transition="dialog-bottom-transition">
      <!-- <ApprovalLevelsDocument :DocEntry="DocEntry" :TypeObject="2" /> -->
      <v-card class="m-0 p-0">
        <s-toolbar label="Control de Pesado" dark :color="'#BAB6B5'" close @close="closeWeighed()"
          class="mb-6"></s-toolbar>
        <weighed-by-batch :ship="ship" v-if="ship == 1"></weighed-by-batch>
        <!-- <frz-weighed-by-batch
          :ship="ship"
          v-if="ship == 2"
        ></frz-weighed-by-batch> -->
      </v-card>
    </v-dialog>
    <!-- modal del muestreo  v-->

    <v-dialog v-model="BrixGrade" fullscreen hide-overlay transition="dialog-bottom-transition" persistent
      v-if="BrixGrade">
      <v-card v-if="ship == 1" class="elevation-0">
        <BrixFresh :items="itemsampling" @close="closeBrixGrade()"></BrixFresh>
      </v-card>
      <!-- <v-card v-else class="elevation-0">
        <FrozenBrix
          :TypeShip="ship"
          :items="itemsampling"
          @close="BrixGrade = false"
        >
        </FrozenBrix>
      </v-card> -->
    </v-dialog>

    <v-dialog v-model="processing" :persistent="messageProcessing.length == 0" width="400">
      <v-card color="primary" dark>
        <v-card-text v-if="messageProcessing.length == 0">
          Por favor espere
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
        <v-card-text v-else>
          <div class="text--white pt-4">
            Error al realizar operacion <br />
            {{ messageProcessing }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-if="openDialogUploadFile" v-model="openDialogUploadFile" persistent max-width="700px">
      <v-card class="rounded-xl overflow-hidden pa-0 elevation-10">
        <AlertSunshine :dialog="loadingCalculate" :text="textLoading" />
        <!-- Header -->
        <div class="modern-header d-flex justify-space-between align-center py-3 px-4"
          style="background: linear-gradient(135deg, #1e293b 0%, #334155 100%);">
          <div class="d-flex align-center">
            <v-icon color="white" class="mr-2" size="24">mdi-qrcode-scan</v-icon>
            <span class="font-weight-bold text-subtitle-1 white--text">
              SUBIR ADJUNTO - LECTOR QR
            </span>
          </div>
          <v-btn icon dark small @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4">
          <!-- Error alert -->
          <v-alert v-if="qrError" dense outlined type="error" class="mb-4 rounded-lg text-caption" dismissible
            @input="qrError = ''">
            {{ qrError }}
          </v-alert>

          <!-- State 1: No file attached -->
          <div v-if="!Attach"
            class="d-flex flex-column align-center justify-center pa-6 rounded-xl grey lighten-4 border-dashed"
            style="height: 250px;">
            <v-icon size="48" color="grey lighten-1" class="mb-2">
              mdi-file-hidden
            </v-icon>
            <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-1">
              Sin archivo adjunto
            </span>
            <span class="text-caption grey--text">
              No se ha registrado ningún documento adjunto para esta recepción.
            </span>
          </div>

          <!-- State 2: Existing file (attached image loaded) -->
          <div v-else class="mt-2">
            <v-row dense>
              <!-- Left side: Image and Download -->
              <v-col cols="12" md="5" class="pa-2 text-center d-flex flex-column align-center">
                <div class="qr-preview-container rounded-xl overflow-hidden elevation-2"
                  style="height: 280px; width: 100%; background-color: #f1f5f9; display: flex; align-items: center; justify-content: center; position: relative;">
                  <v-img :src="retrievedImagePreview || qrImagePreview" max-height="280" contain class="qr-preview-image"></v-img>
                  <!-- Scanner laser while decoding -->
                  <div class="scanner-laser" v-if="qrDecoding"></div>
                </div>
                <div class="mt-3 w-100 d-flex flex-column align-center">
                  <div class="text-caption grey--text text--darken-1 mb-2 text-truncate" style="max-width: 90%;">
                    {{ Attach.name }}
                  </div>
                  <v-btn color="success" outlined class="rounded-lg text-none" @click="openFile(Attach)">
                    <v-icon left>mdi-download</v-icon>
                    Descargar Adjunto
                  </v-btn>
                </div>
              </v-col>

              <!-- Right side: Decoded Content -->
              <v-col cols="12" md="7" class="pa-2">
                <div v-if="qrDecodedContent"
                  class="qr-table-container rounded-xl pa-0 d-flex flex-column justify-center border"
                  style="min-height: 280px;">
                  <div class="d-flex align-center justify-space-between mb-2 px-3">
                    <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3 d-flex align-center">
                      <v-icon left color="success" size="18">mdi-check-circle</v-icon>
                      DATOS DEL QR
                    </span>
                  </div>

                  <div class="qr-table-scroll border rounded-lg overflow-y-auto" style="max-height: 220px;">
                    <v-simple-table dense class="qr-data-table">
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="(item, idx) in parsedQrData" :key="idx">
                            <td class="font-weight-medium text-caption py-1" style="color: #64748b;">
                              <span class="d-inline-block text-truncate" style="max-width: 100px;" :title="item.label">
                                {{ item.label }}
                              </span>
                            </td>
                            <td class="text-caption font-weight-bold py-1 text-selectable"
                              style="color: #1e293b; word-break: break-all;">
                              <div class="d-flex align-center flex-wrap" style="gap: 4px;">
                                <span>{{ item.value }}</span>
                                <template v-if="item.validation">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip v-bind="attrs" v-on="on" x-small
                                        :color="item.validation.isValid ? 'success' : 'error'"
                                        class="white--text px-1 font-weight-bold" label
                                        style="font-size: 0.6rem; height: 16px;">
                                        <v-icon left size="8" class="white--text mr-1">
                                          {{ item.validation.isValid ?
                                            'mdi-check-circle' :
                                            'mdi-alert-circle' }}
                                        </v-icon>
                                        {{ item.validation.isValid ? 'OK' :
                                          'DIFF' }}
                                      </v-chip>
                                    </template>
                                    <span>{{ item.validation.message }}</span>
                                  </v-tooltip>
                                </template>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>

                <!-- Placeholder when decoding or no data -->
                <div v-else
                  class="d-flex flex-column align-center justify-center fill-height pa-6 text-center grey lighten-4 rounded-xl border-dashed"
                  style="height: 280px;">
                  <v-icon size="48" color="grey lighten-1" class="mb-2" :class="{ 'animate-pulse': qrDecoding }">
                    {{ qrDecoding ? 'mdi-qrcode-scan' : 'mdi-table-large' }}
                  </v-icon>
                  <span class="text-caption font-weight-bold grey--text text--darken-2 mb-1">
                    {{ qrDecoding ? 'Decodificando...' : 'Analizando Código QR' }}
                  </span>
                  <span class="text-caption grey--text">
                    {{ qrDecoding ? 'Espere un momento por favor mientras procesamos el QR.' :
                      'Cargando imagen...' }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Hidden input and qrcode component -->
          <qrcode-capture ref="qrCapture" style="display: none;" @decode="onQrDecode" @detect="onQrDetect" />
        </v-card-text>

        <!-- Footer actions -->
        <v-card-actions class="px-4 py-3 grey lighten-4 d-flex justify-end" style="border-top: 1px solid #e2e8f0;">
          <v-btn color="primary" class="text-none rounded-lg" @click="close()">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Para merma -->
    <!-- <v-dialog
			width="700px"
			persistent
			v-model="dialogDecrease"
		>
			<decrease 	@closeDialogDecrease="closeDialogDecrease"
			@saveDecrease="saveDecrease"
			v-model="decrease"
			></decrease>
			
		</v-dialog> -->

    <v-dialog v-model="showTransfer" persistent max-width="450">
      <v-card>
        <v-card-title>Traslado</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div>
            <v-row style="padding-top:12px;">
              <v-col class="s-col-form">
                <s-select-definition label="Destino" v-model="itemHead.TypeDestiny" :def="1175"
                  clearable></s-select-definition>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="HideTransferLP()">Cancelar</v-btn>
          <v-btn color="accent" @click="saveTransferLP()">
            <span v-if="isLoading">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
            <span v-else>
              Guardar
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
//Service
import _sReceptionFresh from "@/services/FreshProduction/ReceptionFreshService";
import _sGenParam from "../../../services/General/ParameterService";
import _sTurnService from "../../../services/FreshProduction/PrfTurnService";

import _sReportService from "@/services/FreshProduction/Report/ReceptionFreshReportService.js";
import _sHarvestSchedule from "../../../services/Technicalassistance/HarvestSchedule.js";
//Component
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectLot from "@/components/HarvestSchedule/SSelectLot.vue";
import Decrease from "@/components/FrozenProduction/Reception/decrease.vue";
import SSelectTransport from "@/components/HarvestSchedule/SSelectTransport";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety";
import SSelectForeman from "@/components/HarvestSchedule/SSelectForeman";
import SSelectDriver from "@/components/HarvestSchedule/sSelectDriver.vue";
import AlertSupplies from "@/components/FreshProduction/FreshReception/AlertSupplies.vue";
import WeighedByBatch from "@/views/FreshProduction/RawMaterialReception/WeighedByBatch";
import FrzWeighedByBatch from "@/views/FrozenProduction/FrzWeighedByBatch/FrzWeighedByBatch";
import SCertificationLot from "@/components/TecnicalAssistence/sCertificationLot.vue";
import BrixFresh from "@/views/FreshProduction/RawMaterialReception/BrixFresh";
import _sGeneral from "@/services/HelperService.js";

import FrozenBrix from "@/views/FrozenProduction/Reception/FrozenBrix";

import sSelectTypeCertification from "@/components/Utils/Certification/sSelectTypeCertification.vue";

import Unload from "./Unload.vue";
import sReceptionFreshUnloadService from '@/services/FreshProduction/ReceptionFreshUnloadService.js';
import { QrcodeCapture } from "vue-qrcode-reader";
import AlertSunshine from "@/components/Utils/AlertSunshine.vue";

export default {
  props: {
    title: {
      type: String,
      default: "Recepción Frescos",
    },
    ship: {
      type: Number,
      default: 1,
    },
  },

  components: {
    Unload,
    FrozenBrix,
    Decrease,
    SSearchLotByCodSenasa,
    SSelectLot,
    SSelectTransport,
    SSelectVariety,
    SSelectForeman,
    SSelectDriver,
    AlertSupplies,
    WeighedByBatch,
    FrzWeighedByBatch,
    SCertificationLot,
    BrixFresh,
    sSelectTypeCertification,
    QrcodeCapture,
    AlertSunshine,
  },

  data() {
    return {
      itemSelected: [],
      dialogTypeFile: false,
      paramDownload: 0,
      dialogUnload: false,
      dialogTurn: false,
      showTransfer: false,
      isLoading: false,
      itemHead: {
        TypeDestiny: 0,
      },
      configTurn: {
        model: {
          TrnID: "ID",
          Actions: "",
          TrnStatus: "",
          TnrDateBegin: "datetime",
          TnrDateEnd: "datetime",
        },
        service: _sTurnService,
        headers: [
          { text: "Id", value: "TrnID", sortable: false, width: "15" },
          {
            text: "Acciones",
            value: "TrnStatus",
            sortable: false,
            width: 70,
          },
          { text: "Turno", value: "TypeTurnName", sortable: false },
          { text: "Inicio", value: "TnrDateBegin", sortable: false },
          { text: "Fin", value: "TnrDateEnd", sortable: false },
          {
            text: "Area",
            value: "TypeAreName",
            sortable: false,
            width: 200,
          },
        ],
      },
      dialogDecrease: false,
      decrease: {},
      FltID: 0,
      RcfIDCert: 0,
      disabledAll: false,
      selectedGang: [],
      selectedVehicle: [],
      itemsGang: [],
      itemsVehicle: [],
      //listSupplies: [],
      dialogWeigh: false,
      BrixGrade: false,
      Attach: null,
      openDialogUploadFile: false,

      itemsampling: {},

      headersGang: [
        { text: "Sub Lote", value: "FltName", width: 300 },
        { text: "Capataz", value: "FrmName", width: 350 },
        {
          text: "Cant. Personal.",
          value: "FrmQuantityHarvester",
          width: 100,
        },
        {
          text: "Cant. Prog.",
          value: "FrmQuantityEstimate",
          width: 100,
        },
        {
          text: "Cant. Cosechadas",
          value: "FrmQuantityReal",
          width: 100,
        },
        {
          text: "Tipo Carga",
          value: "TypeChargeName",
          width: 100,
        },
      ],

      headersVehicle: [
        { text: "Placa", value: "TptEnrollment", width: 150 },
        { text: "Chofer", value: "TptDriver", width: 200 },
        { text: "Tipo de Carga", value: "TypeLoadName", width: 100 },
      ],

      filter: {
        cDateInitial: null,
        cDateFin: null,
        /* cTypeServiceID: 1,
         */
        filterAll: 0,
        TypeDestiny: this.ship,
        TypeState: null,
      },

      config: {
        service: _sReceptionFresh,
        model: {
          RcfID: "ID",
          RcfDateReceptionSurveillance: "date",
          RcfState: "",
          CloseLot: "",
          TypeAlert: "",
          ViewCert: "",
          TypeAlertName: "",
          RcsDateHarvestSchedule: "date",
          WeightGuideVB: "",
          DeclineLot: "",
          UploadFile: ""
        },
        headers: [
          { text: "View", value: "ViewCert", width: 70 },
          { text: "Archivo", value: "UploadFile", width: 70 },
          { text: "Cerrar", value: "CloseLot", width: 50 },
          { text: "Estado", value: "RcfState", width: 20 },
          { text: "Codigo. Lote.", value: "RcfID", width: 100 },
          /*{ text: "Correl", value: "RcfCode", width: 100 },*/
          { text: "Verif.", value: "WeightGuideVB", width: 50 },

          {
            text: "Fec. Cosecha.",
            value: "RcsDateHarvestSchedule",
            width: 140,
          },
          {
            text: "Cant. Jabas Pesadas.",
            value: "AmountJabasWeigh",
            width: 160,
          },

          {
            text: "Guia Cosecha",
            value: "RcfNumberHarvestGuide",
            width: 160,
          },
          /* {
             text: "Peso Total Lote",
             value: "WbbNetWeight",
             width: 160,
           },
           {
             text: "Peso Guia",
             value: "RcfWeightGuide",
             width: 160,
           },
           {
             text: "Tipo Servicio",
             value: "TypeServiceName",
             width: 100,
           },*/
          {
            text: "Guia Remision",
            value: "RcfNumberReferralGuide",
            width: 160,
          },
          { text: "Productor", value: "PrdCardName", width: 260 },
          /*{ text: "Productor Reponsable Cobrar", value: "PrdCardNameResponsable", width: 260 },*/
          { text: "Fundo", value: "FagName", width: 260 },
          /* { text: "Lote", value: "FltName", width: 100 },*/
          { text: "Tipo Cultivo", value: "TypeCropName", width: 160 },
          { text: "Cultivo", value: "TypeCultiveName", width: 160 },
          { text: "Variedad", value: "VrtName", width: 160 },
          { text: "Cod. Senasa", value: "FltCodSenasa", width: 160 },
          {
            text: "Fec. Recep. Vigilancia.",
            value: "RcfDateReceptionSurveillance",
            width: 140,
          },



          /* {
             text: "Peso Muestreado",
             value: "WbbGrossWeight",
             width: 160,
           },*/
          {
            text: "Peso Promedio Fruta",
            value: "WbbWeightAverage",
            width: 160,
          },


          /*   {
               text: "Planta Procesdora",
               value: "TypeProcessingPlantName",
               width: 160,
             },*/
          { text: "Empacadora", value: "TypeBalerName", width: 160 },
          {
            text: "Zona Ubicacion",
            value: "TypeZonLocationName",
            width: 160,
          },
          { text: "Alerta", value: "TypeAlert", width: 100 },
          {
            text: "Observaciones",
            value: "RcfObservations",
            width: 260,
          },
          { text: "CampañaxArea", value: "CmaName", width: 50 },
          { text: "Rechazar", value: "DeclineLot", width: 50 },

        ],
      },

      selected: {},

      openDialogView: false,
      existsData: false,

      objLot: { PrdText: null, FagName: null, FltName: null },

      maskFormatGuideHarvested: "",
      maskFormatGuideRemission: "",
      xCount: 0,
      existUnload: false,

      processing: false,
      error: false,
      messageProcessing: "",

      // Lector QR
      qrFile: null,
      qrImagePreview: null,
      qrDecodedContent: "",
      qrDecoding: false,
      qrError: "",
      qrDragOver: false,
      qrSavingInProgress: false,
      retrievedImagePreview: null,
      qrValidationFailed: false,
      qrIsReviewMode: false,
      loadingCalculate: false,
      textLoading: "",
    };
  },

  computed: {
    uniquePlates() {
      if (!this.itemsVehicle || !Array.isArray(this.itemsVehicle)) return [];
      const plates = this.itemsVehicle.filter(item => item && item.TptEnrollment)
        .map(item => String(item.TptEnrollment).trim()).filter(plate => plate !== '');
      return [...new Set(plates)];
    },
    parsedQrData() {
      if (!this.qrDecodedContent) return [];
      const content = this.qrDecodedContent.trim();

      // Funciones auxiliares para normalización y comparación robusta
      const normalizeString = (str) => {
        if (!str) return "";
        return String(str)
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") // quitar acentos
          .replace(/[^a-z0-9]/g, ""); // conservar sólo letras y números
      };

      const extractDateOnly = (str) => {
        if (!str) return "";
        // Extraer formato DD/MM/YYYY o YYYY-MM-DD
        const match = str.match(/(\d{2})[/-](\d{2})[/-](\d{4})/);
        if (match) return `${match[1]}/${match[2]}/${match[3]}`;
        const matchYmd = str.match(/(\d{4})[/-](\d{2})[/-](\d{2})/);
        if (matchYmd) return `${matchYmd[3]}/${matchYmd[2]}/${matchYmd[1]}`;
        return str.split(',')[0].trim();
      };

      const extractNumber = (str) => {
        if (!str) return null;
        const match = str.match(/\d+(\.\d+)?/);
        return match ? parseFloat(match[0]) : null;
      };

      let result = [];

      // 0. Detectar formato personalizado de Clave-Valor (e.g. -Exportador->...)
      if (content.includes('->')) {
        const regex = /-([^\r\n\-&=>]+)->/g;
        const keys = [];
        let match;
        while ((match = regex.exec(content)) !== null) {
          keys.push({
            name: match[1].trim(),
            index: match.index,
            length: match[0].length
          });
        }

        if (keys.length > 0) {
          for (let i = 0; i < keys.length; i++) {
            const currentKey = keys[i];
            const valueStart = currentKey.index + currentKey.length;
            const valueEnd = (i + 1 < keys.length) ? keys[i + 1].index : content.length;
            const value = content.substring(valueStart, valueEnd).trim();
            result.push({
              label: currentKey.name,
              value: value || '-'
            });
          }
        }
      }
      // 1. Detectar si es el formato de SUNAT (separado por pipes '|')
      else if (content.includes('|')) {
        const parts = content.split('|');
        const labels = [
          "RUC Emisor",
          "Tipo Documento",
          "Serie",
          "Número Correlativo",
          "Impuesto / Valor",
          "Total",
          "Fecha Emisión",
          "Tipo Doc. Adquiriente",
          "Nro. Doc. Adquiriente",
          "Hash / Firma"
        ];

        const getDocTypeName = (type) => {
          if (type === '09') return 'Guía de Remisión Remitente';
          if (type === '31') return 'Guía de Remisión Transportista';
          if (type === '01') return 'Factura Electrónica';
          if (type === '03') return 'Boleta de Venta';
          return type;
        };

        result = parts.map((part, index) => {
          let label = labels[index] || `Dato Adicional ${index + 1}`;
          let val = part.trim();
          if (index === 1) val = `${val} - ${getDocTypeName(val)}`;
          return { label, value: val || '-' };
        });
      }
      // 2. Detectar si es una URL con parámetros de consulta
      else if (content.startsWith('http://') || content.startsWith('https://')) {
        try {
          const url = new URL(content);
          result.push({ label: 'Enlace / URL', value: content });
          result.push({ label: 'Dominio', value: url.hostname });

          url.searchParams.forEach((val, key) => {
            let label = key;
            const keyLower = key.toLowerCase();
            if (keyLower === 'rucemisor') label = 'RUC Emisor';
            else if (keyLower === 'serienumero') label = 'Serie-Número';
            else if (keyLower === 'fechaemision') label = 'Fecha Emisión';
            else if (keyLower === 'ruc') label = 'RUC';
            else if (keyLower === 'nro') label = 'Número';
            else if (keyLower === 'placa') label = 'Placa';

            result.push({ label, value: val });
          });
        } catch (e) {
          // Fallback
        }
      }
      // 3. Detectar si es JSON
      else if (content.startsWith('{') && content.endsWith('}')) {
        try {
          const obj = JSON.parse(content);
          result = Object.entries(obj).map(([key, val]) => {
            const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
            return { label, value: String(val) };
          });
        } catch (e) {
          // Fallback
        }
      }
      // 4. Texto simple
      else {
        result = [
          { label: 'Tipo de Lectura', value: 'Texto Genérico / Código Único' },
          { label: 'Contenido QR', value: content }
        ];
      }

      // Realizar las validaciones cruzadas si hay datos disponibles
      if (result.length > 0) {
        const qrPlacaObj = result.find(item => {
          const l = normalizeString(item.label);
          return l === 'placa' || l === 'vehplate' || l === 'nroplaca';
        });
        const qrJabasObj = result.find(item => {
          const l = normalizeString(item.label);
          return l === 'jabas' || l === 'cantidad' || l === 'cantjabas' || l === 'jabasreal' || l === 'jabasreales';
        });

        result = result.map(item => {
          const labelNorm = normalizeString(item.label);
          const valNorm = normalizeString(item.value);
          let validation = null;

          // 1. LugarProd vs Cod. Senasa (objLot.FltCodSenasa)
          if (labelNorm === 'lugarprod') {
            const formSenasa = this.objLot ? this.objLot.FltCodSenasa : '';
            const formSenasaNorm = normalizeString(formSenasa);
            if (formSenasaNorm) {
              const match = valNorm === formSenasaNorm;
              validation = {
                isValid: match,
                expected: formSenasa,
                message: match ? 'Coincide con Cod. Senasa' : `No coincide con Cod. Senasa (${formSenasa})`
              };
            } else {
              validation = { isValid: false, expected: 'No asignado', message: 'Cod. Senasa no asignado en el lote del formulario' };
            }
          }

          // 2. Placa vs Vehiculos Programados y Jabas vs Jabas Cosechadas
          else if (labelNorm === 'placa' || labelNorm === 'vehplate' || labelNorm === 'nroplaca') {
            const vehList = this.itemsVehicle || [];
            const normalizedPlacaVal = normalizeString(item.value);

            // const matchingGang = vehList.find(g => normalizeString(g.TptEnrollment) === normalizedPlacaVal);
            const matchingGang = vehList.find(g => g && g.TptEnrollment && normalizeString(g.TptEnrollment) === normalizedPlacaVal);

            if (matchingGang) {
              let jabasMatch = true;
              let jabasMessage = "";
              // const expectedRealJabas = this.itemsGang.reduce((sum, item) => sum + (item.FrmQuantityReal || 0), 0);
              const expectedRealJabas = (this.itemsGang || []).reduce((sum, i) => sum + (i.FrmQuantityReal || 0), 0);

              if (qrJabasObj) {
                const qrJabasNum = extractNumber(qrJabasObj.value);
                if (qrJabasNum !== null && Number(expectedRealJabas) !== qrJabasNum) {
                  jabasMatch = false;
                  jabasMessage = ` (QR: ${qrJabasNum} und vs Prog: ${expectedRealJabas} und)`;
                }
              }

              validation = {
                isValid: jabasMatch,
                expected: matchingGang.TptEnrollment,
                message: jabasMatch
                  ? 'Coincide con Placa y Jabas Cosechadas'
                  : `Placa coincide, pero las jabas cosechadas no coinciden${jabasMessage}`
              };
            } else {
              validation = {
                isValid: false,
                expected: 'Placa en Vehículos',
                message: 'La placa no coincide con los Vehículos Programados'
              };
            }
          }

          // 3. Validar fila Jabas directamente
          else if (labelNorm === 'jabas' || labelNorm === 'cantidad' || labelNorm === 'cantjabas' || labelNorm === 'jabasreal' || labelNorm === 'jabasreales') {
            const vehList = this.itemsVehicle || [];
            const qrPlacaVal = qrPlacaObj ? normalizeString(qrPlacaObj.value) : '';
            // const matchingGang = vehList.find(g => normalizeString(g.TptEnrollment) === qrPlacaVal);
            const matchingGang = vehList.find(g => g && g.TptEnrollment && normalizeString(g.TptEnrollment) === qrPlacaVal);

            if (matchingGang) {
              // const expectedRealJabas = this.itemsGang.reduce((sum, item) => sum + (item.FrmQuantityReal || 0), 0);
              const expectedRealJabas = (this.itemsGang || []).reduce((sum, i) => sum + (i.FrmQuantityReal || 0), 0);
              const qrJabasNum = extractNumber(item.value);
              const match = qrJabasNum !== null && qrJabasNum === expectedRealJabas;
              validation = {
                isValid: match,
                expected: String(expectedRealJabas),
                message: match ? 'Coincide con Jabas Cosechadas' : `No coincide con Jabas Cosechadas (${expectedRealJabas})`
              };
            } else {
              validation = {
                isValid: false,
                expected: 'Jabas Programadas',
                message: 'No se puede validar las jabas sin una placa de vehículo coincidente'
              };
            }
          }

          return { ...item, validation };
        });
      }

      return result;
    }
  },

  created() {
    this.loadParameter();
  },

  methods: {
    syncLot() {
      console.log(this.selected);

      if (this.selected.RcfID == null) {
        return;
      }

      _sReceptionFresh.syncLot(this.selected, this.$fun.getUserID())
        .then(r => {
          console.log("r sync", r);
          if (r.status == 200) {
            this.$fun.alert("Se sincronizo correctamente", "success");
          }

        });

    },
    verififyDownloadRcf() {
      /*  if(this.itemsampling.RcfID != undefined){
         sReceptionFreshUnloadService
         .searchbyrcfid(this.itemsampling.RcfID, this.$fun.getUserID())
         .then(resp => {
           if(resp.status == 200){
             if(resp.data && resp.data.RftDateEnd != null){
               this.existUnload = true;
               console.log('ddddddddddd ', resp.data);
             }else{
               this.existUnload = false;
             }
           }
         })
       } */

    },

    openModalfilesGeneral(param) {
      this.paramDownload = param;
      this.dialogTypeFile = true;
    },

    filesGeneralDownloadExcel() {
      if (this.paramDownload == 1) {
        this.reportBRIX();
      } else {
        this.reportINTAKE();
      }
    },

    filesGeneralDownloadPdf() {
      if (this.paramDownload == 1) {
        this.reportBrixPDF();
      } else {
        this.reportIntakePDF();
      }
    },

    viewModalUnload() {
      this.dialogUnload = true;
    },

    closeModalUnload() {
      this.dialogUnload = false;
    },

    close() {
      this.openDialogUploadFile = false;
      this.clearQrScanner();
    },
    /*     reportBRIX() {
          _sReportService
            .BRIX({ TrnID: 1, TnrBeginDate: "23/02/2022" })
            .then((r) => {
              this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, "BRIX");
            });
        },
    
        reportBrixPDF() {
          let obj = { TrnID: 1 };
          _sReportService.brixRPdf(obj, this.$fun.getUserID()).then((r) => {
            this.$fun.downloadFile(
              r.data,
              this.$const.TypeFile.PDF,
              "Control indicencia madurez de la fruta"
            );
          });
        },
    
        reportINTAKE() {
          _sReportService
            .INTAKE({ TrnID: 1, TnrBeginDate: "23/02/2022" })
            .then((r) => {
              this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, "INTAKE");
            });
        },
    
        reportIntakePDF() {
          let obj = { TrnID: 1 };
          _sReportService.IntakeRPdf(obj, this.$fun.getUserID()).then((r) => {
            this.$fun.downloadFile(
              r.data,
              this.$const.TypeFile.PDF,
              "Inspección en reception sobre la calidad de la materia prima"
            );
          });
        },
    
        reportEntryMaterial() {
          _sReportService
            .entryMaterial({ TrnID: 1, TnrBeginDate: "23/02/2022" })
            .then((r) => {
              this.$fun.downloadFile(
                r.data,
                this.$const.TypeFile.EXCEL,
                "Entrada de Materia Prima"
              );
            });
        }, */

    loadParameter() {
      _sGenParam
        .search({ PrmName: "maskFormatGuideHarvested" }, this.$fun.getUserID())
        .then((resp) => {
          if (resp.status == 200) {
            this.maskFormatGuideHarvested = resp.data.PrmValue;
          }
        });

      _sGenParam
        .search({ PrmName: "maskFormatGuideRemission" }, this.$fun.getUserID())
        .then((resp) => {
          if (resp.status == 200) {
            this.maskFormatGuideRemission = resp.data.PrmValue;
          }
        });
    },

    closeBrixGrade() {
      this.BrixGrade = false;
      this.$refs.gridReceptionFresh.refresh();
    },

    closeDialogDecrease() {
      this.dialogDecrease = false;
    },

    saveDecrease(item) {
      this.decrease = item;
    },

    rowClickGang: function (item, row) {
      this.selectedGang = [item];
    },

    rowClickVehicle: function (item, row) {
      this.selectedVehicle = [item];
    },

    clickView(val) {
      this.FltID = val.FltID;
      this.RcfIDCert = val.RcfID;
      this.openDialogView = true;
    },

    clickUploadFile(val) {
      this.selected = val;
      this.qrError = "";
      this.qrValidationFailed = false;
      this.qrIsReviewMode = false;
      this.qrDecodedContent = "";
      this.qrImagePreview = null;
      this.retrievedImagePreview = null;
      this.qrFile = null;

      if (val.HvsAttach) {
        this.Attach = { name: val.HvsAttach };
        const isImage = /\.(apng|avif|gif|jpg|jpeg|jfif|pjpeg|pjpg|png|svg|webp)$/i.test(val.HvsAttach);
        if (isImage) {
          this.textLoading = "Descargando y decodificando adjunto...";
          this.loadingCalculate = true;
          _sGeneral.download(val.HvsAttach, this.$fun.getUserID()).then((r) => {
            if (r && r.data) {
              const ext = val.HvsAttach.split('.').pop().toLowerCase();
              const mime = ext === 'png' ? 'image/png' : ext === 'webp' ? 'image/webp' : 'image/jpeg';
              if (r.data instanceof Blob) {
                this.processExistingFile(r.data, val.HvsAttach, mime);
              } else {
                const base64Data = r.data;
                if (typeof base64Data === 'string') {
                  const cleanBase64 = base64Data.startsWith('data:') ? base64Data.split(',')[1] : base64Data;
                  const byteCharacters = atob(cleanBase64);
                  const byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
                  const byteArray = new Uint8Array(byteNumbers);
                  const blob = new Blob([byteArray], { type: mime });
                  this.processExistingFile(blob, val.HvsAttach, mime);
                } else {
                  this.loadingCalculate = false;
                }
              }
            } else {
              this.loadingCalculate = false;
            }
          }).catch(err => {
            console.error("Error downloading image preview:", err);
            this.loadingCalculate = false;
          });
        }
      } else {
        this.Attach = null;
      }
      this.openDialogUploadFile = true;
    },

    processExistingFile(blobData, filename, mime) {
      const file = new File([blobData], filename, { type: mime });
      this.Attach = file;
      this.qrFile = file;
      this.qrDecoding = true;
      this.qrValidationFailed = false;
      this.qrImagePreview = URL.createObjectURL(file);
      this.retrievedImagePreview = this.qrImagePreview;

      this.$nextTick(() => {
        try {
          const captureComponent = this.$refs.qrCapture;
          if (captureComponent) {
            const inputEl = captureComponent.$el;
            const targetInput = inputEl.tagName === 'INPUT' ? inputEl : inputEl.querySelector('input');
            if (targetInput) {
              const dataTransfer = new DataTransfer();
              dataTransfer.items.add(file);
              targetInput.files = dataTransfer.files;
              targetInput.dispatchEvent(new Event('change'));
            } else {
              this.qrDecoding = false;
              this.loadingCalculate = false;
            }
          } else {
            this.qrDecoding = false;
            this.loadingCalculate = false;
          }
        } catch (err) {
          console.error("Error decoding existing file:", err);
          this.qrDecoding = false;
          this.loadingCalculate = false;
        }
      });
    },

    onQrDecode(result) {
      this.qrDecodedContent = result;
      this.qrDecoding = false;
      this.loadingCalculate = false;
      this.checkQrValidation();
    },

    onQrDetect(promise) {
      this.qrDecoding = true;
      promise.then((result) => {
        if (result && result.content) {
          this.qrDecodedContent = result.content;
          this.checkQrValidation();
        }
      }).catch((err) => {
        this.qrError = "No se detectó ningún código QR en la imagen. Intente con otra foto más clara.";
        this.qrDecodedContent = "";
        this.qrValidationFailed = true;
      }).finally(() => {
        this.qrDecoding = false;
        this.loadingCalculate = false;
      });
    },

    checkQrValidation() {
      this.$nextTick(() => {
        const hasDiff = this.parsedQrData.some(item => item.validation && !item.validation.isValid);
        if (hasDiff) {
          this.qrValidationFailed = true;
          this.qrError = "El QR no cumple con los requisitos de los datos.";
          this.$fun.alert("El QR no cumple con los requisitos de los datos.", "error");
        } else {
          const hasOk = this.parsedQrData.some(item => item.validation && item.validation.isValid);
          if (!hasOk) {
            this.qrValidationFailed = true;
            this.qrError = "No se detectaron datos de validación válidos en el código QR.";
          } else {
            this.qrValidationFailed = false;
            this.qrError = "";
          }
        }
      });
    },

    clearQrScanner() {
      this.Attach = null;
      this.qrFile = null;
      this.qrImagePreview = null;
      this.retrievedImagePreview = null;
      this.qrDecodedContent = "";
      this.qrError = "";
      this.qrValidationFailed = false;
      this.qrIsReviewMode = false;
      if (this.$refs.qrFileInput) {
        this.$refs.qrFileInput.value = "";
      }
    },

    closeCert() {
      this.openDialogView = false;
    },

    closeWeighed() {
      this.dialogWeigh = false;
      this.$refs.gridReceptionFresh.refresh();
    },

    WeighMaterial() {
      this.dialogWeigh = true;
    },
    generateCorrelative(item) {
      console.log("generateCorrelative", item);
      _sReceptionFresh
        .generateCorrelative(item, this.$fun.getUserID())
        .then((r) => {
          this.$fun.alert("Correlativo generado", "success");
          this.$refs.gridReceptionFresh.refresh();
        });
    },
    disabledCorrelative(item) {
      return !(item.RcfCode === null && this.existsData === true);
    },
    ModalBrix() {
      this.BrixGrade = true;
    },

    rowSelected(item) {
      if (!this.openDialogUploadFile) {
        this.clearQrScanner();
      }
      if (item.length == 0) {
        this.selected = {};
        this.objLot = {};
        this.itemsGang = [];
        this.itemsVehicle = [];
        this.disabledAll = false;
        this.existsData = false;

        //this.hasSuppliesNotRecommended = false;
      } else {
        if (item[0] != undefined) {

          // let selected = { ...item[0] }
          this.selected = { ...item[0] }
          this.existsData = true;

          _sReceptionFresh.GetGang({ RcfID: this.selected.RcfID }, this.$fun.getUserID()).then((r) => {
            this.itemsGang = r.data;
            console.log("this.itemsGang", JSON.parse(JSON.stringify(this.itemsGang)));

            if (this.itemsGang.length > 0) {
              if (this.selected.RcfNumberFerralGuideDriver == null || this.selected.RcfNumberFerralGuideDriver === "") {
                this.$set(this.selected, 'RcfNumberFerralGuideDriver', this.itemsGang[0].TasGngGuideTransport);
                if (this.$refs.gridReceptionFresh && this.$refs.gridReceptionFresh.row) {
                  this.$set(this.$refs.gridReceptionFresh.row, 'RcfNumberFerralGuideDriver', this.itemsGang[0].TasGngGuideTransport);
                }
              }

              // if (this.selected.RcfNumberFerralGuideMaterials == null || this.selected.RcfNumberFerralGuideMaterials === "") {
              //   this.$set(this.selected, 'RcfNumberFerralGuideMaterials', this.itemsGang[0].TasGngGuideTransport);
              //   if (this.$refs.gridReceptionFresh && this.$refs.gridReceptionFresh.row) {
              //     this.$set(this.$refs.gridReceptionFresh.row, 'RcfNumberFerralGuideMaterials', this.itemsGang[0].TasGngGuideTransport);
              //   }
              // }

              if (!this.selected.RcfNumberFerralGuideDriverMaterials || this.selected.RcfNumberFerralGuideDriverMaterials === "") {
                this.$set(this.selected, 'RcfNumberFerralGuideDriverMaterials', this.itemsGang[0].TasGngGuideTransportMaterials);
                if (this.$refs.gridReceptionFresh && this.$refs.gridReceptionFresh.row) {
                  this.$set(this.$refs.gridReceptionFresh.row, 'RcfNumberFerralGuideDriverMaterials', this.itemsGang[0].TasGngGuideTransportMaterials);
                }
              }
            }

          }).finally(() => {
            // this.selected = selected;
            console.log("finally", JSON.parse(JSON.stringify(this.selected)));
          });

          _sReceptionFresh.GetTransport({ RcfID: this.selected.RcfID }, this.$fun.getUserID()).then((r) => {
            this.itemsVehicle = r.data;
          });

          this.objLot.PrdText = this.selected.PrdCardName;
          this.objLot.FagName = this.selected.FagName;
          this.objLot.FltName = this.selected.FltName;

          this.objLot.PrdID = this.selected.PrdID;
          this.objLot.FagID = this.selected.FagID;
          this.objLot.FltID = this.selected.FltID;
          this.objLot.FltCodSenasa = this.selected.FltCodSenasa;
          this.objLot.TypeCrop = this.selected.TypeCrop;
          this.objLot.TypeCultive = this.selected.TypeCultive;
          this.objLot.VrtID = this.selected.VrtID;

          this.objLot.FagAddress = this.selected.FagAddres;
          this.objLot.ZonIDText = this.selected.ZonName;
          this.objLot.SzoIDText = this.selected.SzoName;
          this.objLot.TypeNegociation = this.selected.TypeNegociation;

          if (this.selected.RcfState >= 4) {
            this.disabledAll = true;
          } else {
            this.disabledAll = false;
          }
        }
      }

      this.itemSelected = this.selected;
      this.itemSelected.itemsVehicle = this.itemsVehicle;

      this.itemsampling = this.selected;
      this.verififyDownloadRcf();
      console.log("print ", this.selected);
    },

    openFile(url) {
      console.log("Nombre de url", url);
      _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
        console.log("rtpa", r);
        this.$fun.download(r.data, url.name);
        // if(r.status === 200){

        // 	this.$fun.downloadHttp(r);
        // }       
      });
    },

    isValidatedForeman() {
      let isValidated = true;
      //Validar Grilla Capataces
      if (this.itemsGang.length == 0) {
        this.$fun.alert(
          "La Recepcion: " +
          this.selected.RcfID +
          ", No cuenta con Capataces asignados.",
          "warning"
        );
        isValidated = false;
        return;
      }

      this.itemsGang.forEach((element) => {
        console.log("element", element);

        if (element.FrmID == null) {
          this.$fun.alert(
            "Uno de los registro no se ha cargado Capataz",
            "warning"
          );
          isValidated = false;
          return;
        }

        if (element.FltID == null) {
          this.$fun.alert(
            "Uno de los registro no se ha cargado Sub-Lote",
            "warning"
          );
          isValidated = false;
          return;
        }

        if (element.FrmQuantityHarvester <= 0) {
          this.$fun.alert(
            "Cantidad de Cosechadores no puede ser menor o igual a 0, para Capataz: " +
            element.FrmName,
            "warning"
          );
          isValidated = false;
          return;
        }

        if (element.FrmQuantityReal <= 0) {
          this.$fun.alert(
            "Cantidad de Fruta no puede ser menor o igual a 0, para Capataz: " +
            element.FrmName,
            "warning"
          );
          isValidated = false;
          return;
        }
      });

      return isValidated;
    },

    isValidatedVehicle() {
      let isValidated = true;

      if (this.selected.FrzID == 0) {
        //Validar Grilla Vehiculos

        if (this.itemsVehicle.length == 0) {
          this.$fun.alert(
            "La Recepcion: " +
            this.selected.RcfID +
            ", No cuenta con Vehiculos asignados.",
            "warning"
          );
          isValidated = false;
          return;
        }

        this.itemsVehicle.forEach((element) => {
          if (element.TptEnrollment == null) {
            this.$fun.alert("Necesita especificar un Vehiculo", "warning");
            isValidated = false;
            return;
          }

          if (element.TptDriver == null) {
            this.$fun.alert("Necesita especificar un Chofer", "warning");
            isValidated = false;
            return;
          }

          if (element.TypeLoad == null) {
            this.$fun.alert("Necesita especificar tipo de carga", "warning");
            isValidated = false;
            return;
          }
        });
      }
      return isValidated;
    },

    isValidatedDocuments(val) {
      let isValidated = true;
      if (
        val.RcfNumberHarvestGuide == "" ||
        val.RcfNumberHarvestGuide == null
      ) {
        this.$fun.alert("Ingrese Numero Guia de Cosecha", "warning");
        isValidated = false;
        return;
      }

      if (this.selected.FrzID == 0) {
        if (
          val.RcfNumberReferralGuide == "" ||
          val.RcfNumberReferralGuide == null
        ) {
          this.$fun.alert("Ingrese numero Guia de Remision", "warning");
          isValidated = false;
          return;
        }

        if (
          val.RcfNumberFerralGuideDriver == "" ||
          val.RcfNumberFerralGuideDriver == null
        ) {
          this.$fun.alert(
            "Ingrese numero Guia remision de Transportista",
            "warning"
          );
          isValidated = false;
          return;
        }
      }

      return isValidated;
    },

    isValidatedHeader(val) {
      let isValidated = true;

      if (val.RcfID == 0) {
        this.$fun.alert("No se ha seleccionado registro", "warning");
        isValidated = false;
        return;
      }

      if (this.objLot.PrdText == null || this.objLot.PrdText == undefined) {
        this.$fun.alert("No se ha seleccionado Productor", "warning");
        isValidated = false;
        return;
      }

      if (this.objLot.FagName == null || this.objLot.FagName == undefined) {
        this.$fun.alert("No se ha seleccionado Fundo", "warning");
        isValidated = false;
        return;
      }

      if (this.objLot.FltName == null || this.objLot.FltName == undefined) {
        this.$fun.alert("No se ha seleccionado Lote", "warning");
        isValidated = false;
        return;
      }

      if (
        this.objLot.TypeCultive == undefined ||
        this.objLot.TypeCultive == null
      ) {
        this.$fun.alert("No se ha seleccionado Cultivo", "warning");
        isValidated = false;
        return;
      }

      if (this.objLot.TypeCrop == undefined || this.objLot.TypeCrop == null) {
        this.$fun.alert("No se ha seleccionado Tipo Cultivo", "warning");
        isValidated = false;
        return;
      }

      return isValidated;
    },
    ReceptionLot(items) {
      //console.log("cerrar lote", items);

      this.$fun
        .alert("Esta seguro de Recepcionar el Lote ? ", "question")
        .then((val) => {
          if (val.value) {
            items.itemsVehicle = null
            items.RcfState = 50;
            items.UsrCreateID = this.$fun.getUserID();

            console.log("cerrar lote", items);

            _sReceptionFresh.save(items, this.$fun.getUserID()).then((r) => {
              if (r.status == 200) {
                this.$fun.alert("Lote Recepcionado correctamente", "success");
                this.$refs.gridReceptionFresh.refresh();
              }
            });
            this.$refs.gridReceptionFresh.refresh();
          }
        });
    },
    DeclineLot(items) {
      //console.log("cerrar lote", items);

      this.$fun
        .alert("Esta seguro de Rechazar el Lote ? ", "question")
        .then((val) => {
          if (val.value) {
            items.itemsVehicle = null
            items.RcfState = 40;
            items.UsrCreateID = this.$fun.getUserID();

            console.log("cerrar lote", items);

            _sReceptionFresh.save(items, this.$fun.getUserID()).then((r) => {
              if (r.status == 200) {
                this.$fun.alert("Lote Rechazado correctamente", "success");
                this.$refs.gridReceptionFresh.refresh();
              }
            });
            this.$refs.gridReceptionFresh.refresh();
          }
        });
    },
    closeLot(items) {
      //console.log("cerrar lote", items);
      if (items.RcfState >= 4) {
        this.$fun.alert(
          "Lote se encuentra ==> " + items.TypeStateName,
          "warning"
        );
        return;
      }

      this.$fun
        .alert("Esta seguro de Cerrar el Lote ? ", "question")
        .then((val) => {
          if (val.value) {
            items.itemsVehicle = null
            items.RcfState = 4;
            items.UsrCreateID = this.$fun.getUserID();

            console.log("cerrar lote", items);

            _sReceptionFresh.save(items, this.$fun.getUserID()).then((r) => {
              if (r.status == 200) {
                this.$fun.alert("Lote cerrado correctamente", "success");
                this.$refs.gridReceptionFresh.refresh();
              }
            });
            this.$refs.gridReceptionFresh.refresh();
          }
        });
    },

    save(val) {
      if (val.RcfState >= 4) {
        this.$fun.alert(
          "Lote se encuentra ==> " +
          val.TypeStateName +
          ", No se puede modifcar.",
          "warning"
        );
        return;
      }

      if (!this.isValidatedHeader(val)) {
        return;
      }
      if (!this.isValidatedForeman()) {
        return;
      }
      if (!this.isValidatedVehicle()) {
        return;
      }
      if (!this.isValidatedDocuments(val)) {
        return;
      }

      this.xCount = 0;
      val.SecStatus = 1;
      val.UsrCreateID = this.$fun.getUserID(); //Obtenemos el ID del Usuario
      //val.RcfState = 1;
      val.RcfDateReception = this.$fun.getDate();

      val.PrdID = this.objLot.PrdID;
      val.FagID = this.objLot.FagID;
      val.FltID = this.objLot.FltID;

      val.TypeCrop = this.objLot.TypeCrop;
      val.TypeCultive = this.objLot.TypeCultive;
      val.VrtID = this.objLot.VrtID;
      val.TypeNegociation = this.objLot.TypeNegociation;

      //Verificamos que Planta Procesadora es Sunshine, Establecemos Empacadora en NULL
      if (val.TypeProcessingPlant == 1) {
        val.TypeBaler = null;
      }

      //Agregamos el RcsID a Capataces
      this.itemsGang.forEach((element) => {
        element.RcfID = val.RcfID;
        element.SecStatus = 1;
        element.UsrCreateID = this.$fun.getUserID();
      });

      //Agregamos el RcsID a Vehiculos
      this.itemsVehicle.forEach((element) => {
        element.RcfID = val.RcfID;
        element.SecStatus = 1;
        element.UsrCreateID = this.$fun.getUserID();

        if (element.TypeLoad == 1) {
          this.xCount = this.xCount + 1;
        }
      });

      val.itemsGang = this.itemsGang;
      val.itemsVehicle = this.itemsVehicle;

      if (this.selected.FrzID == 0) {
        if (this.xCount > 1) {
          this.$fun.alert(
            "Error... El Lote de Producción solo puede tener 01 vehiculo para transporte de Fruta",
            "warning"
          );
          return;
        }

        if (this.xCount == 0) {
          this.$fun.alert(
            "Error... El Lote de Producción no contiene vehiculo para transporte de Fruta",
            "warning"
          );
          return;
        }
      }

      console.log("Guardar", val);

      this.$fun.alert("Seguro de Guardar?", "question")
        .then(r => {
          if (r.value) {
            this.processing = true;
            _sReceptionFresh
              .save(val, this.$fun.getUserID())
              .then(resp => {
                if (resp.status == 200) {
                  this.processing = false;
                  this.$fun.alert("Guardado Correctamente", "success");
                  this.$refs.gridReceptionFresh.refresh()
                }
              },
                (e) => {
                  this.error = true;
                  this.messageProcessing = e.response.data.Message;
                  this.processing = true;
                }

              );
          }
        })

      //val.save();
    },

    openAudio() {
      var audio = new Audio(require("../../../../../sound/nohaynadie.mp3"));
      audio.play();
    },

    searchSenasa(item) {
      if (item) this.objLot = item;
      else this.objLot = {};

      console.log("this.objLot", this.objLot);
    },

    editEvent() {
      if (this.existsData == false) {
        this.$fun.alert("No se ha seleccionado registro", "warning");
      }
    },

    enableLP() {
      this.$fun
        .alert("¿ Esta seguro de Habilitar Lote Producción ?", "question")
        .then((x) => {
          if (x.value) {
            this.selected.RcfState = 20;
            this.selected.UsrCreateID = this.$fun.getUserID();

            _sReceptionFresh
              .save(this.selected, this.$fun.getUserID())
              .then((resp) => {
                if (resp.status == 200) {
                  this.$fun.alert("LP Habilitado", "success");
                  this.$refs.gridReceptionFresh.refresh();
                }
              });
          }
        });
    },
    TransferLP() {
      this.showTransfer = true;
    },
    HideTransferLP() {
      this.showTransfer = false;
    },
    saveTransferLP() {

      if (!this.itemHead.TypeDestiny) {
        this.$fun.alert("Por favor seleccione un destino", "warning");
        return;
      }

      if (this.selected.TypeDestiny == this.itemHead.TypeDestiny) {
        this.$fun.alert("Por favor seleccione un destino diferente", "warning");
        return;
      }

      this.selected.TypeDestiny = this.itemHead.TypeDestiny;
      this.selected.UsrUpdateID = this.$fun.getUserID();
      console.log("this.selected.RcfID", this.selected.RcfID);

      _sReceptionFresh
        .TranferLPFresh(this.selected, this.$fun.getUserID())
        .then((resp) => {
          console.log("respuesta", resp);
          if (resp.status == 200) {
            this.$fun.alert("LP Trasladado", "success");
            this.$refs.gridReceptionFresh.refresh();
            this.itemHead.TypeDestiny = 0;
            this.showTransfer = false;
            this.isLoading = false;
          }
        });

    },
  },
};
</script>
<!-- <v-dialog v-model="dialogTurn" v-if="dialogTurn" width="700">
            <v-col>
              <v-card>
                <v-col cols="12" lg="12" md="12" class="pb-0">
                  <s-crud
                    :config="configTurn"
                    :filter="{ TypeAre: 1, TypeAre: 1 }"
                    no-search
                    title="Reportes por Turnos"
                    ref="gridTurn"
                    no-full
                    height="auto"
                  >
                    <template v-slot:options>
                      <v-btn
                        class="mr-1"
                        color="warning"
                        x-small
                        @click="openModalfilesGeneral(1)"
                      >
                        BRIX</v-btn
                      >
                      <v-btn
                        class="mr-1"
                        color="success"
                        x-small
                        @click="openModalfilesGeneral(2)"
                      >
                        INTAKE</v-btn
                      >
                      <v-btn
                        class="mr-1"
                        color="primary"
                        x-small
                        @click="dialogTurn = true"
                      >
                        CAMIONES</v-btn
                      >
                      <v-btn
                        color="primary"
                        x-small
                        @click="reportEntryMaterial()"
                      >
                        INGRESO MATERIAL</v-btn
                      >
                    </template>

                    <template v-slot:TrnStatus="{ row }">
                      <v-btn
                        x-small
                        :color="row.TrnStatus == 1 ? 'error' : 'default'"
                        :height="25"
                        rounded
                        style="margin: 10px 10px 10px 5px"
                        ><i
                          style="font-size: 16px; margin-right: 6px"
                          class="far fa-stop-circle"
                        ></i>
                        {{ row.TrnStatus == 1 ? "Turno Activo " : "Terminado" }}
                      </v-btn>
                    </template>
                  </s-crud>
                </v-col>
              </v-card> -->
<!-- ventana de si es archivo excel o pdf -->

<!--               <v-dialog
                v-if="dialogTypeFile"
                v-model="dialogTypeFile"
                width="300"
              >
                <v-card>
                  <v-container>
                    <v-row justify="center">
                      <v-col>
                        <v-btn
                          color="green"
                          dark
                          @click="filesGeneralDownloadExcel()"
                          ><v-icon style="padding-right: 10px"
                            >fa-solid fa-file-excel</v-icon
                          >Excel</v-btn
                        >
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col>
                        <v-btn
                          color="red"
                          dark
                          @click="filesGeneralDownloadPdf()"
                        >
                          <v-icon style="padding-right: 10px"
                            >fa-solid fa-file-pdf</v-icon
                          >
                          Pdf</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-col>
          </v-dialog> -->


<!-- <template v-slot:options>
          <v-btn
            class="mr-1"
            color="success"
            x-small
            @click="dialogTurn = true"
          >
            Turnos</v-btn
          > -->
<!-- <v-btn 
            color="primary" 
            x-small 
            @click="viewModalUnload()"
            :disabled="existUnload"
          >
            Descarga Fruta</v-btn
          >
          <v-dialog v-model="dialogUnload" v-if="dialogUnload" width="700">
            <unload
              @closeModalUnload="closeModalUnload()"
              :item="itemSelected"
            ></unload>
          </v-dialog> -->




<!-- </template> -->

<style scoped>
/* QR Scanner Styling */
.qr-dropzone {
  border: 2px dashed #cfd8dc;
  background-color: #f8fafc;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.qr-dropzone:hover,
.qr-dropzone.drag-over {
  border-color: #1976d2 !important;
  background-color: #f0f7ff !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.1);
}

.qr-preview-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 280px;
  background-color: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
}

.qr-preview-image {
  max-height: 100%;
  max-width: 100%;
}

.scanner-laser {
  position: absolute;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, rgba(239, 68, 68, 0) 0%, rgba(239, 68, 68, 1) 50%, rgba(239, 68, 68, 0) 100%);
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.8);
  animation: scanning 2s linear infinite;
  z-index: 2;
}

@keyframes scanning {
  0% {
    top: 0%;
  }

  50% {
    top: 100%;
  }

  100% {
    top: 0%;
  }
}

.bg-light-blue {
  background-color: #f0f9ff !important;
}

.border-dashed {
  border: 2px dashed #e2e8f0 !important;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: .5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* QR Table Styling */
.qr-table-container {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
}

.qr-table-scroll {
  max-height: 220px;
  overflow-y: auto;
}

.qr-data-table th {
  font-size: 0.72rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e2e8f0 !important;
}

.qr-data-table td {
  font-size: 0.75rem !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.qr-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.text-selectable {
  user-select: text !important;
}
</style>